import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from './error.component';
import { ErrorRoutingModule } from './error-routing';
import { NotFoundComponent } from './404/404.component';
import { UnauthorizedComponent } from './401/401.component';
import { ForbiddenComponent } from './403/403.component';
import { InternalErrorComponent } from './500/500.component';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslationLoader } from '../translation/custom-http-translate.loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoader,
        deps: [HttpClient]
      }
    }),
    ErrorRoutingModule
  ],
  declarations: [ErrorComponent, NotFoundComponent, UnauthorizedComponent, ForbiddenComponent, InternalErrorComponent]
})
export class ErrorModule {
  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang("pt");
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.languageCode){
      translate.use(user.languageCode);
    } else {
      translate.use('pt');
    }
  }
 }
